import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

const useExecutions = (id, days = null) => {
  var endDate = new Date().toISOString()
  var date = new Date(endDate)

  if (days) {
    date.setDate(date.getDate() - days)
  } else {
    date.setMonth(date.getMonth() - 3)
  }

  var startDate = date.toISOString()
  return useQuery(
    {
      queryKey: ['executions', (id + 'simulations')],
      queryFn: () => fetchExecutions(id, startDate, endDate),
      // keepPreviousData: true,
      staleTime: 1000,
    }
  )
}

export const useExecutionsByDates = (id, chain, startDate, endDate) => {
  return useQuery(
    {
      queryKey: ['executions', id, chain, startDate, endDate],
      queryFn: () => fetchExecutions(id, startDate, endDate),
      // keepPreviousData: true,
      staleTime: 1000,
    }
  )
}

const fetchExecutions = async (id, startDate, endDate) => {
  if (!id) return []
  const url = `https://api.mimic.fi/public/environments/${id}/simulations`

  try {
    const params = {
      startDate: startDate,
      endDate: endDate,
    }

    const { data } = await axios.get(url, {
      params: { ...params }
    })

    return data
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return false
    }
    throw error
  }
}

export default useExecutions
